export default {
      id: "productivity-focus-usage",
      viewBox: "0 0 64 64",
      url: __webpack_public_path__ + "assets/images/lantern-icons.svg#productivity-focus",
      toString: function () {
        return this.url;
      }
    }